import { useEffect, useState } from 'react';

// Extend the Window interface to include stockcarsMarketPath
declare global {
  interface Window {
    stockcarsMarketPath?: string;
    stockcarsScsStartPage?: string;
  }
}

export function useFavorites(vehicleId: string) {
  let localStorageKey: string = 'VTP__';
  if (typeof window !== 'undefined') {
    localStorageKey = `VTP_${window.stockcarsMarketPath ?? ''}_${window.stockcarsScsStartPage ?? ''}`;
  }
  const [isFavorite, setIsFavorite] = useState<Boolean>(false);
  const [favorites, setFavorites] = useState<String[]>([]);
  const [localStorageObject, setLocalStorageObject] = useState<any>();
  function updateLocalStorage(newFavorites: String[]) {
    const newLocalStorageObject = {
      ...localStorageObject,
      favoriteVehiclesIds: newFavorites,
    };
    localStorage.setItem(localStorageKey, JSON.stringify(newLocalStorageObject));
    setLocalStorageObject(newLocalStorageObject);
  }
  function changeFavoriteStatus() {
    let newFavorites: String[];
    if (isFavorite) {
      newFavorites = favorites.filter((favorite) => favorite !== vehicleId);
      setFavorites(newFavorites);
      updateLocalStorage(newFavorites);
    } else {
      newFavorites = favorites;
      newFavorites.push(vehicleId);
      setFavorites(newFavorites);
      updateLocalStorage(newFavorites);
    }
    setIsFavorite(!isFavorite);
  }
  useEffect(() => {
    const receivedLocalStorage = JSON.parse(localStorage.getItem(localStorageKey) ?? '{}');
    setLocalStorageObject(receivedLocalStorage);
  }, []);
  useEffect(() => {
    if (localStorageObject && localStorageObject.favoriteVehiclesIds) {
      setFavorites(localStorageObject.favoriteVehiclesIds);
      setIsFavorite(localStorageObject.favoriteVehiclesIds.includes(vehicleId));
    }
  }, [localStorageObject]);
  return { isFavorite, favorites, changeFavoriteStatus };
}
